import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { ProfileInfoCard, ViewButton } from "@components";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { PunishmentType } from "@type/HRM/punishments";

import { ROUTES } from "@constants/routes";
import { TABS } from "@constants/tab-serial";

const {
  HRM: { EMPLOYEES },
} = ROUTES;

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  return [
    {
      id: 1,
      key: "name",
      name: t("EMPLOYEES.TABLE.COLUMN.NAME"),
      render: (_: string, row: PunishmentType) => (
        <ProfileInfoCard employee={row.employee} />
      ),
    },
    {
      id: 2,
      key: "employeeCode",
      name: t("PUNISHMENT_HISTORY_LIST.TABLE_COLUMN.EMPLOYEE_ID"),
      render: (employeeCode: string) => (
        <Text color="info">{employeeCode}</Text>
      ),
    },
    {
      id: 3,
      key: "offenceNature",
      name: t("PUNISHMENT_HISTORY_LIST.TABLE_COLUMN.TYPE_OF_PUNISHMENT"),
      render: (offenceNature: string, row: PunishmentType) => (
        <div className="d-flex flex-column gap-2">
          <Text weight="bold" color="warning">
            {offenceNature}
          </Text>
          <Text color="subtitle2">{row.punishmentDetails}</Text>
        </div>
      ),
    },

    {
      id: 3,
      key: "date",
      name: t("PUNISHMENT_HISTORY_LIST.TABLE_COLUMN.DATE"),
      render: (date: string) => (
        <div className="d-flex flex-column gap-2">
          <Text color="subtitle2" className="text-nowrap">
            {date}
          </Text>
        </div>
      ),
    },

    {
      id: 5,
      key: "remarks",
      name: t("PUNISHMENT_HISTORY_LIST.TABLE_COLUMN.REMARKS"),
      render: (remarks: string) => <Text color="info">{remarks}</Text>,
    },
    {
      ...(getAccess(roles, "PUNISHMENT_UPDATE") && {
        id: 5,
        key: "view",
        render: (_: number, row: any) => {
          return <ViewButton link={`${EMPLOYEES}/${row.employeeID}?tab=${TABS.DISCIPLINE}`} />;
        },
      }),
    },
  ];
};
